import {
    useMemo,
} from 'react'
import {
    useSkyNetNavigate, SkyNetRoutesConfig, createRoutesConfig,
} from 'app/SkyNetRoutes/index'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import useCreateSkyNetDomainRoutes from 'app/shared-components/SkyNetDomain/useCreateSkyNetDomainRoutes'
import {
    App,
    DamageTrackingDomains,
} from 'app/enums/domain.enums'

export default function useDamageTrackingRoutes() {
    const skyNetNavigate = useSkyNetNavigate()
    const SkyNetDomainRoutes = useCreateSkyNetDomainRoutes()()

    return useMemo(() => {
        const config: SkyNetRoutesConfig = {
            path: [App.DamageTracking],
            Damages: {
                route: DamageTrackingDomains.Damages,
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                ChangeHistory: {
                    route: CommonRoutes.ChangeHistory,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
            DamageTypes: {
                route: DamageTrackingDomains.DamageTypes,
                Overview: {
                    route: CommonRoutes.Overview,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                Update: {
                    route: CommonRoutes.DataUpdate,
                    via: SkyNetDomainRoutes.All.Edit,
                },
                ChangeHistory: {
                    route: CommonRoutes.ChangeHistory,
                    via: SkyNetDomainRoutes.All.Edit,
                },
            },
        }

        return createRoutesConfig(skyNetNavigate)(config)
    }, [
        SkyNetDomainRoutes,
        skyNetNavigate,
    ])
}
